import {Checkbox, Radio} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Tooltip} from '@/components/Tooltip';
import {useResponsive} from '@/contexts/ResponsiveContext';

const CardTypeSelect = ({
  value,
  disableKeys,
  options,
  translate,
  valueKey,
  labelKey,
  isButton,
  fullWidth,
  isCheckBox,
  isRow,
  ...rest
}) => {
  const {t} = useTranslation(translate || 'common');
  const {isMobile} = useResponsive();
  
  isButton = useMemo(() => isButton && !isMobile, [isButton, isMobile]);
  const RadioCmp = isButton ? Radio.Button : (!isCheckBox ? Radio : Checkbox);
  
  const GroupCmp = isCheckBox ? Checkbox.Group : Radio.Group;
  
  const handlerBuildOptions = (record, index) => {
    const isSelected = value === record[valueKey];
    const isDisabled = disableKeys?.some(e => e === record[valueKey]);
    
    return <RadioCmp
      className={classNames(
        {'flex-1': fullWidth},
        {'mb-2': !isButton},
        {'opacity-25': isDisabled},
        {'mb-0 flex items-center justify-center text-center': isButton}, 'text-base ml-0'
      )}
      style={isButton && record.color ? {
        lineHeight: '20px',
        minHeight: '80px',
        borderColor: record.color,
        color: isSelected ? 'white' : record.color,
        background: isSelected ? record.color : 'transparent',
      } : {}}
      key={index}
      
      disabled={isDisabled}
      value={record[valueKey]}>
      <Tooltip title={t(record?.help)}>
        {t(record[labelKey])}
      </Tooltip>
    </RadioCmp>;
  };
  
  return (<GroupCmp value={value} {...rest} buttonStyle="solid"
    className={classNames('flex', {'flex-col': !isButton && !isRow}, {'flex-row': isButton || isRow})}>
    {options.map((key, index) => {
      return handlerBuildOptions(key, index);
    })}
  </GroupCmp>);
  
};

export default memo(CardTypeSelect);

CardTypeSelect.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  isButton: PropTypes.bool,
  isRow: PropTypes.bool,
  fullWidth: PropTypes.bool,
  isCheckBox: PropTypes.bool,
  disableKeys: PropTypes.array,
  labelKey: PropTypes.string,
  initialValue: PropTypes.string,
  valueKey: PropTypes.string,
  translate: PropTypes.string,
  value: PropTypes.string
};

CardTypeSelect.defaultProps = {
  fullWidth: true,
  isButton: true,
  valueKey: 'value',
  labelKey: 'label',
  options: [],
  disableKeys: [],
};
